import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const ALLERGENS = [
  "Celery", "Cereals containing gluten", "Crustaceans", "Eggs", "Fish", "Lupin", "Milk",
  "Molluscs", "Mustard", "Nuts (tree nuts)", "Peanuts", "Sesame", "Soya", "Sulphur dioxide / sulphites",
];

export default function AllergenInfo() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8" data-testid="allergen-page">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold">Allergen Information</p>
        <h1 className="mt-3 font-serif text-3xl font-bold tracking-tight text-cream-text sm:text-4xl">
          Your safety comes first
        </h1>
      </Reveal>

      <Reveal className="mt-8">
        <div className="rounded-3xl border border-gold/50 bg-choco-light p-6 sm:p-8" data-testid="allergen-warning-panel">
          <div className="flex items-start gap-3">
            <AlertTriangle className="mt-0.5 h-6 w-6 shrink-0 text-gold" aria-hidden="true" />
            <div>
              <h2 className="font-serif text-xl font-semibold text-cream-text">
                If you have a food allergy, please contact us before ordering
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-cream-muted">
                Our bakes are handmade in a kitchen that handles common allergens, including wheat (gluten),
                eggs, milk, soya and nuts. Because everything is made in one kitchen, we cannot guarantee that
                any product is completely free from traces of any allergen. We'll always be honest about what
                we can and can't do — so please talk to us first.
              </p>
              <Link to="/contact" className="mt-4 inline-block text-sm font-bold text-gold hover:underline" data-testid="allergen-contact-link">
                Contact us about an allergy
              </Link>
            </div>
          </div>
        </div>
      </Reveal>

      <Reveal className="mt-10">
        <h2 className="font-serif text-2xl font-bold text-cream-text">The 14 major allergens</h2>
        <p className="mt-3 text-sm leading-relaxed text-cream-muted">
          Every product page lists the ingredients and the allergens that product contains. The 14 allergens
          recognised in UK law are:
        </p>
        <ul className="mt-5 grid grid-cols-1 gap-2.5 sm:grid-cols-2" data-testid="allergen-list">
          {ALLERGENS.map((a) => (
            <li key={a} className="rounded-xl border border-choco-line bg-choco-light px-4 py-3 text-sm text-cream-text">
              {a}
            </li>
          ))}
        </ul>
        <p className="mt-6 text-sm leading-relaxed text-cream-muted">
          Please note: a product is not described as “free from” an allergen simply because that allergen is
          not in the recipe — cross-contact is always possible in a small bakery kitchen.
        </p>
      </Reveal>
    </div>
  );
}
